<template>
  <vs-card>
    <vs-table hoverFlat stripe :data="menus" search pagination max-items="15">
      <template slot="header">
        <h3>
          Kategóriák
        </h3>
        <vs-button radius color="success" type="gradient" icon="add" @click="addMenu()"></vs-button>
      </template>
      <template slot="thead">
        <vs-th>
          Megnevezés
        </vs-th>
        <vs-th>
          Látható
        </vs-th>
        <vs-th>
          Doboz
        </vs-th>
        <vs-th>
        </vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr :key="index" v-for="(tr, index) in data">
          <vs-td>
            {{ tr.MenuName }}
          </vs-td>
          <vs-td >
            <vs-icon v-if="parseInt(tr.Visible) === 1" size="small" icon="check" color="success" type="gradient"></vs-icon>
            <vs-icon v-else size="small" icon="clear" color="danger" type="gradient"></vs-icon>
          </vs-td>
          <vs-td >
            <vs-icon v-if="parseInt(tr.WithBox) === 1" size="small" icon="check" color="success" type="gradient"></vs-icon>
            <vs-icon v-else size="small" icon="clear" color="danger" type="gradient"></vs-icon>
          </vs-td>
          <vs-td>
            <vs-row vs-type="flex" vs-align="right" vs-justify="flex-end">
              <vs-button radius color="warning" size="small" type="gradient" icon="build"
                         @click="editMenu(tr.Id)"></vs-button>
              <vs-button radius color="danger" size="small" type="gradient" icon="clear"
                         @click="delMenu(tr.Id)"></vs-button>
            </vs-row>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>

    <div class="centerx">
      <vs-popup classContent="addMenuModal" title="Új kategória hozzáadása" :active.sync="addModal"
                @closemodal="closeModal()">
        <new_menu v-bind:selected="selected"></new_menu>
      </vs-popup>
    </div>

    <div class="centerx">
      <vs-popup classContent="editMenuModal" title="Kategória módosítása" :active.sync="editModal"
                @closemodal="closeModal()">
        <edit_menu v-bind:selected="selected"></edit_menu>
      </vs-popup>
    </div>
  </vs-card>
</template>

<script>
import {axiosInstance} from "@/main";
import new_menu from "../../components/modals/new_menu";
import edit_menu from "../../components/modals/edit_menu";

export default {
  name: "menus",
  data() {
    return {
      menus: [],
      editModal: false,
      addModal: false,
      selected: {
        Id: '',
        MenuName: '',
        PickupOnly: false,
        MenuFileName: '',
        MaxOrderHour: 20,
        ClosestDelivery: 'today',
        Visible: 0,
        WithBox: 0,
        InfoText: ''
      }
    }
  },
  components: {
    new_menu, edit_menu
  },
  methods: {
    closeModal() {
      this.editModal = false;
      this.addModal = false;
      this.getMenus();
    },
    getMenus() {
      let self = this;
      axiosInstance
          .get('admin/menuController.php', {
            withCredentials: true,
          })
          .then((response) => {
            this.menus = response.data.responseData;
          })
          .catch((err) => {
            if (err.response.status === 401)
              self.$root.exterminatus(err.response.data.message);
            else {
              self.$vs.notify({
                title: 'Rendszerüzenet',
                position: 'top-right',
                text: err.response.data.message,
                color: 'danger',
                icon: 'error'
              });
            }
          });
    },
    addMenu() {
      this.selected.MenuName = '';
      this.addModal = true;
    },
    editMenu(id) {
      this.selected = {...this.menus.find(elem => elem.Id === id)};
      this.editModal = true;
    },
    delMenu(id) {
      let self = this;
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Megerősítés`,
        text: 'Valóban törölni kívánja a kategóriát?',
        acceptText: 'Igen',
        cancelText: 'Nem',
        accept: function () {
          axiosInstance
              .delete('admin/menuController.php?id=' + id, {
                withCredentials: true,
              })
              .then((resp) => {
                self.getMenus();
                self.$vs.notify({
                  title: 'Rendszerüzenet',
                  position: 'top-right',
                  text: resp.data.status === 'OK' ? 'Sikeres törlés.' : 'Sikertelen törlés. ' + resp.data.message,
                  color: resp.data.status === 'OK' ? 'success' : 'danger',
                  icon: resp.data.status === 'OK' ? 'check_box' : 'error'
                });
              })
              .catch((err) => {
                if (err.response.status === 401)
                  self.$root.exterminatus(err.response.data.message);
                else {
                  self.$vs.notify({
                    title: 'Rendszerüzenet',
                    position: 'top-right',
                    text: err.response.data.message,
                    color: 'danger',
                    icon: 'error'
                  });
                }
              });
        }
      });
    }
  },
  created() {
    this.getMenus();
  }
}
</script>

<style scoped>
h3 {
  padding: 15px;
}

.vs-input {
  margin-top: 15px;
  margin-bottom: 15px;
  width: 100%;
}

form {
  width: 100%;
}

.vs-icon {
  margin-left: 15px;
}

.vs-button {
  margin: 1px 5px;
}

</style>